import { Component } from '@angular/core';
import { Sportshome, SportsHomeService, gametype, SharedService, EventStatus, ConfigService, SportsFilter, SportBetPanelService, SportsFilterService } from 'baseline-lib';
import { Global } from '../../../global/global';
import { SportsBetslipPage } from '../sports-betslip/sports-betslip';
import { NavController } from 'ionic-angular';
import { SportsMenuPage } from '../sports-menu-page/sports-menu-page';

/**
 * Generated class for the SportsHomeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sports-home',
  templateUrl: 'sports-home.html'
})
export class SportsHomeComponent {

  text: string;
  sportsHomeObj: Sportshome;
  _marketData: any[] = [];
  socket: any;
  _imageUrl: any;
  _sportsFilter: SportsFilter;
  inplay : boolean = false;

  params : any;
  pageFrom : string;

  constructor(public _sportsHomeService : SportsHomeService,public _sharedService : SharedService,
    public _globalData : Global,public _configService : ConfigService,public navCtrl : NavController,
    public _sportBetPanelService : SportBetPanelService, public _sportsFilterService : SportsFilterService,
    public globalData : Global) {
      this.sportsHomeObj = new Sportshome();
      this._imageUrl = this._configService.getImageUrl();
      this.pageFrom = "sportsHome";
      //this.globalData.selectedGameId == 0;
  }

  ngOnInit(){
    // this.globalData.isLoaderShownHomepage = true;
    this._sportsHomeService.gameList = [];
    this._sportsHomeService.setSportsGame();
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;         
  }
 
  openSportsMenuPage(){
    this.navCtrl.push(SportsMenuPage);
  }
  
  openBetSlipPage(){
    this.navCtrl.push(SportsBetslipPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/sports/sports-home/sports-home.ts